import { IntegrationSettingsEntry, IntegrationSettingsAccountLevelForm } from 'modules/integrationSettings/types';
import { IntegrationSettingsTable } from './IntegrationSettingsTable';
import { Box } from '@mui/material';

interface AccountTabProps {
  integrationSettings: IntegrationSettingsEntry[];
  tableData: IntegrationSettingsAccountLevelForm[];
}

export const AccountTab = ({ integrationSettings, tableData }: AccountTabProps) => {
  return (
    <Box mt={2}>
      <IntegrationSettingsTable integrationSettings={integrationSettings} tableData={tableData} />
    </Box>
  );
};
